<!--Paragraph with title alongside image on top of a colorful banner.
    Required:
    - Paragraph title
    - Paragraph text
    - image
    - choice of side for image display
-->

<template>
  <mdb-container>
    <mdb-row class="default-color py-5">
      <mdb-col
        v-if="block.value.image_side === 'left'"
        class="d-none d-lg-block"
        lg="4"
      >
        <img
          class="d-none d-lg-block rounded img-fluid"
          md="4"
          :src="`${block.value.image.image.src}`"
        />
      </mdb-col>
      <mdb-col class="text-left" md="8">
        <h2>
          <strong>{{block.value.title}}</strong>
        </h2>
        <p>{{block.value.text}}</p>
      </mdb-col>
      <mdb-col
        v-if="block.value.image_side === 'right'"
        class="d-none d-lg-block"
        lg="4"
      >
        <img
          class="d-none d-lg-block rounded img-fluid"
          md="4"
          :src="`${block.value.image.image.src}`"
        />
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
export default {
  name: "paragraph_and_image_banner",
  props: {
    block: Object
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol
  },
};
</script>